import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row q-gutter-x-lg form-field" }
const _hoisted_2 = {
  key: 0,
  class: "row col fused-fields"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_local_date_picker = _resolveComponent("local-date-picker")!
  const _component_iuf_select = _resolveComponent("iuf-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_local_date_picker, {
      label: _ctx.t('EFFECTIVE_DATE.LABEL'),
      mandatory: "",
      class: "col",
      "model-value": _ctx.effectiveDate,
      "to-limit": _ctx.expirationDate,
      "onUpdate:modelValue": _ctx.updateEffectiveDate
    }, null, 8, ["label", "model-value", "to-limit", "onUpdate:modelValue"]),
    (!_ctx.noExpiration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_iuf_select, _mergeProps({
            class: _ctx.desktopView ? 'col-6' : 'col-12',
            options: _ctx.datePeriodOptions
          }, _ctx.SELECT_SINGLE_LG, {
            modelValue: _ctx.datePeriod,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datePeriod) = $event)),
            "option-label": "label",
            "option-value": "value",
            label: `${_ctx.t('EXPIRATION_DATE.DURATION')}${_ctx.desktopView ? '' : `/${_ctx.t('EXPIRATION_DATE.LABEL')}`}`
          }), null, 16, ["class", "options", "modelValue", "label"]),
          _createVNode(_component_local_date_picker, {
            class: _normalizeClass(_ctx.desktopView ? 'col-6' : 'col-12'),
            "from-limit": _ctx.effectiveDate,
            label: _ctx.desktopView ? _ctx.t('EXPIRATION_DATE.LABEL') : undefined,
            "model-value": _ctx.expirationDate,
            clearable: "",
            "onUpdate:modelValue": _ctx.expirationDateDirectInput
          }, null, 8, ["class", "from-limit", "label", "model-value", "onUpdate:modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}